import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { gispertSection6 } from '../utils/gispertContent6';
import { gispertSection6En } from '../utils/gispertContent6En';
import { getRelatedSectionsForGispert } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';
import ContentGate from './ContentGate';

const Gispert6 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? gispertSection6En : gispertSection6;
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('spain_project_unlocked') === 'true') {
      setIsUnlocked(true);
    }
  }, []);


  return (
    <div className='TesisPage TesisPage--gispert'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForGispert('/Gispert6')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('gispert6.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('gispert6.subtitle')}</h2>
      <article className='TesisPageContent'>
        {isUnlocked ? (
          <>
            {content.map((p, i) => <p key={i}>{p}</p>)}
          </>
        ) : (
          <ContentGate onUnlocked={() => setIsUnlocked(true)} />
        )}
      </article>
    </div>
  );
};

export default Gispert6;
